import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const host = document.getElementById("shadow-root");

const shadow = host.attachShadow({ mode: "open" });
const app = document.createElement("div");
app.setAttribute("id", "app-root");

const bootstrapStyles = document.createElement("link");
bootstrapStyles.setAttribute("rel", "stylesheet");
bootstrapStyles.setAttribute("href", process.env.PUBLIC_URL + "/assets/bootstrap.min.css");

const appStyles = document.createElement("link");
appStyles.setAttribute("rel", "stylesheet");
appStyles.setAttribute("href", process.env.PUBLIC_URL + "/assets/styles.css");

shadow.appendChild(bootstrapStyles);
shadow.appendChild(appStyles);
shadow.appendChild(app);

const root = ReactDOM.createRoot(app);

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
